import React, { FormEvent, ReactElement } from 'react';
import {
  Button,
  Col, Heading, LoaderButton, Row, Text,
} from 'idsk-react-components';
import { v4 as uuidv4 } from 'uuid';
import { BackButton } from 'slovlex-idsk-react-components';
import DoktrinalnaDefiniciaItem from './DoktrinalnaDefiniciaItem';
import Definicia from '../../../../../model/Definicia';
import addIcon from '../../../../../../assets/images/icon-plus-dark.svg';

interface Props {
  doktrinalneDefinicie: Array<Definicia>;
  setDoktrinalneDefinicie: (doktrinalneDefinicie: Array<Definicia>) => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  getFieldErrorMessage: (fieldName: string) => string | undefined;
  clearFieldErrorMessage?: (fieldName: string) => void;
  clearAllFieldErrorMessages?: () => void;
  loading: boolean;
}

const DoktrinalneDefinicieUpdateForm = ({
  doktrinalneDefinicie,
  setDoktrinalneDefinicie,
  onSubmit,
  getFieldErrorMessage,
  clearFieldErrorMessage,
  clearAllFieldErrorMessages,
  loading,
}: Props): ReactElement => {
  const addDefinicia = async (): Promise<void> => {
    setDoktrinalneDefinicie([...doktrinalneDefinicie, {
      key: uuidv4(), definicia: '', zdroj: '', uuid: '', popisLegislativnehoZdroja: '',
    }]);
  };

  return (
    <>
      <Heading size="l">Doktrinálne definície</Heading>
      <form onSubmit={onSubmit} className="admin-termin-create-form">
        {doktrinalneDefinicie?.map((definicia, index) => (
          <DoktrinalnaDefiniciaItem
            key={definicia.key || definicia.uuid}
            itemList={doktrinalneDefinicie}
            setItemList={setDoktrinalneDefinicie}
            itemId={index}
            getFieldErrorMessage={getFieldErrorMessage}
            clearFieldErrorMessage={clearFieldErrorMessage}
            clearAllFieldErrorMessages={clearAllFieldErrorMessages}
          >
            {index === doktrinalneDefinicie.length - 1 && (
              <Button
                size="large"
                onClick={addDefinicia}
                iconBefore={addIcon}
                buttonStyle="third"
              >Pridať doktrinálnu definíciu
              </Button>
            )}
          </DoktrinalnaDefiniciaItem>
        ))}
        {doktrinalneDefinicie.length === 0 && (
          <>
            <Text className="doktrinalna-definicia-item">
              Prázdny zoznam doktrinálnych definícií.
            </Text>
            <Button
              size="large"
              onClick={addDefinicia}
              iconBefore={addIcon}
              buttonStyle="third"
            >Pridať doktrinálnu definíciu
            </Button>
          </>
        )}
        <Row className="admin-termin-create__actions">
          <Col width="one-half">
            <LoaderButton
              className="admin-termin-create__create-button"
              loading={loading}
              type="submit"
              size="large"
            >
              Uložiť zmeny
            </LoaderButton>
            <BackButton disabled={loading} />
          </Col>
        </Row>
      </form>
    </>
  );
};

export default DoktrinalneDefinicieUpdateForm;
